export default __webpack_public_path__ + "static/media/unlockStatsDark@2x.38932b80.png";